import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { SubmitButton } from '~components'
import { object, string } from '~utils/validation'
import { Values } from './interfaces'
import { useStore, usePathValidation, useNavigate } from '~hooks'
import * as Styled from './styled'
import React, { useEffect } from 'react'
import { track } from '@amplitude/analytics-browser'

function Plate() {
  const { plate: initialPlate, update } = useStore()
  const defaultValues = {
    plate: initialPlate || '',
  }
  const navigate = useNavigate()
  const schema = object({
    plate: string().plate('Placa inválida.'),
  })
  const {
    register,
    handleSubmit,
    watch,
    formState: { isValid, errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: 'onChange',
  })
  const plate = watch('plate')

  useEffect(() => {
    track('cadastro_placa')
  }, [])
  useEffect(() => {
    if (errors.plate && plate.length === 8) {
      track('cadastro_login_cpf', { errormessage: 'placa_invalida' })
    }
  }, [errors, plate])
  usePathValidation(['cpf', 'register.cellphone', 'register.fullName'])
  useEffect(() => {
    update({ register: { progress: 20 } })
  }, [update])

  function onSubmit(values: Values) {
    update(values)
    navigate('/cadastrar/tipo-veiculo', { state: { previousPath: '/cadastrar/placa'}})
  }
  function handleShowValidation(value: string) {
    return value.length === 8
  }
  function handleInput(event: React.KeyboardEvent<HTMLInputElement>) {
    const target = event.nativeEvent.target as HTMLInputElement
    target.value = target.value
      .split('-')
      .join('')
      .replace(/[^a-z0-9-]+/gi, '')
    if (target.value.length >= 3) {
      target.value = target.value.replace(/(.{3})(.+)/, '$1-$2')
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} aria-labelledby="form-plate-title">
      <Styled.Title id="form-plate-title">Digite a placa do veículo</Styled.Title>
      <Styled.Field
        autoFocus
        onInput={handleInput}
        defaultValue={defaultValues.plate}
        maxLength={8}
        name="plate"
        label="Placa"
        showSuccess
        register={register}
        whenShowValidation={handleShowValidation}
        error={errors.plate}
        isValid={isValid}
      />
      <SubmitButton width="100%" disabled={!isValid}>
        Continuar
      </SubmitButton>
    </form>
  )
}

export default Plate
